import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { MUTATE } from "../../utilities/network";
import countries from "../../pages/settings/countryCode.json";
import { TextField, Grid, MenuItem, Button } from "@material-ui/core";
import { CREATE_GROUP } from "../../constants/requests";
import { toast } from "react-toastify";

const AddGroupForm = ({ setShowModal, fetchComparedGroups }) => {
  const formik = useFormik({
    initialValues: { name: "", description: "", country: "" },
    onSubmit: async (values) => {
      if (!formik.errors.length) {
        await MUTATE(CREATE_GROUP, values);
        toast.success("Group successfully created", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        setShowModal(false);
        fetchComparedGroups();
      }
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Group name is required"),
      description: Yup.string().max(50, "Must be 50 characters or less"),
      country: Yup.string().required("Group country is required"),
    }),
  });

  const { handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting } = formik;

  const groupName = {
    name: "name",
    id: "groupName",
    label: "Group name",
    variant: "outlined",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.name,
  };

  const groupDescription = {
    name: "description",
    id: "groupDescription",
    label: "Group description",
    variant: "outlined",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.description,
  };

  const groupCountry = {
    name: "country",
    id: "groupCountry",
    label: "Group country",
    variant: "outlined",
    onChange: handleChange,
    options: countries,
    value: `${values.country}`,
  };

  return (
    <form style={{ width: "100%", margin: "20px" }} onSubmit={handleSubmit}>
      <Grid container spacing={3} justify="space-between">
        <Grid item xs={12}>
          <TextField
            {...groupName}
            fullWidth
            required
            aria-describedby="group-name"
            error={errors.name && touched.name}
            helperText={touched.name && errors.name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            {...groupDescription}
            fullWidth
            aria-describedby="group-description"
            error={errors.description && touched.description}
            helperText={touched.description && errors.description}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            {...groupCountry}
            fullWidth
            required
            select
            aria-describedby="group-country"
            error={errors.country && touched.country}
            helperText={touched.country && errors.country}
          >
            {countries.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
            Add Group
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default AddGroupForm;
